"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSessionToJSON = exports.RecentSessionFromJSONTyped = exports.RecentSessionFromJSON = void 0;
var runtime_1 = require("../runtime");
function RecentSessionFromJSON(json) {
    return RecentSessionFromJSONTyped(json, false);
}
exports.RecentSessionFromJSON = RecentSessionFromJSON;
function RecentSessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'gameTitle': !(0, runtime_1.exists)(json, 'gameTitle') ? undefined : json['gameTitle'],
        'duration': !(0, runtime_1.exists)(json, 'duration') ? undefined : json['duration'],
        'xpEarned': !(0, runtime_1.exists)(json, 'xpEarned') ? undefined : json['xpEarned'],
        'timestamp': !(0, runtime_1.exists)(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
    };
}
exports.RecentSessionFromJSONTyped = RecentSessionFromJSONTyped;
function RecentSessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'gameTitle': value.gameTitle,
        'duration': value.duration,
        'xpEarned': value.xpEarned,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
    };
}
exports.RecentSessionToJSON = RecentSessionToJSON;
